const api = {
  json: {
    integration: {
      name: '',
      description: '',
      integrationType: 'endNode',
      endNode: {
        endNodeType: 'api',
        outputVars: {
          responseHttpStatus: '',
          responseBody: '',
          responseContentType: '',
        },
      },
    },
    type: 'integration',
  },
  paths: [
    'integration.name',
    'integration.description',
    'integration.endNode.outputVars.responseContentType',
    'integration.endNode.outputVars.responseHttpStatus',
    'integration.endNode.outputVars.responseBody',
  ],
  groups: [
    {
      Parameters: [
        'integration.name',
        'integration.description',
        'integration.endNode.outputVars.responseContentType',
        'integration.endNode.outputVars.responseHttpStatus',
        'integration.endNode.outputVars.responseBody',
      ],
    },
  ],
  layout: {
    name: {
      type: 'text',
      label: 'Name',
      validators: {
        required: true,
        spaceOnName: true,
      },
    },
    description: {
      type: 'text',
      label: 'Description',
      validators: {
        required: true,
      },
    },
    responseHttpStatus: {
      type: 'text',
      label: 'HTTP status',
      validators: {
        required: true,
      },
    },
    responseContentType: {
      type: 'dropdown',
      label: 'Response Content Type header',
      attributes: {
        options: {
          'application/json': 'application/json',
          'application/xml': 'application/xml',
          'text/plain': 'text/plain',
          'text/xml': 'text/xml',
        },
      },
      validators: {
        required: true,
      },
    },
    responseBody: {
      type: 'textarea',
      label: 'Response body',
      validators: {
        required: true,
      },
    },
  },
};

export const apiEndNode: {} = {
  api: api,
};
